import type { ProcessStep } from 'src/types/content';

import { Reveal } from './reveal';

type NightTimelineProps = {
  steps: ProcessStep[];
};

export function NightTimeline({ steps }: NightTimelineProps) {
  return (
    <Reveal className="nightline">
      {steps.map((step) => (
        <div key={step.title} className="nstep">
          <span className="ntime">{step.time}</span>
          <h3>{step.title}</h3>
          <p>{step.text}</p>
        </div>
      ))}
    </Reveal>
  );
}
